<template>
    <div class="container">
        <div class="row login-container">
            <!-- Image Section -->

            <!-- Login Form Section -->
            <div class="col-lg-6 d-flex align-items-center justify-content-center">
                <div class="text-center">
                    <img src="@/assets/images/logo.png" alt="Logo" class="mb-3" style="width: 113px;">
                    <h3 class="mb-4">تسجيل الدخول</h3>

                    <form>
                        <div class="mb-3 text-end">
                            <img src="@/assets/images/login/email.png" class="ico" style="width: 18px;">
                            <label class="form-label">البريد الإلكتروني</label>
                            <input type="email" class="form-control" placeholder="أدخل بريدك الإلكتروني">
                        </div>
                        <div class="mb-3 text-end">
                            <img src="@/assets/images/login/password.png" class="ico">
                            <label class="form-label">كلمة المرور</label>
                            <input type="password" class="form-control" placeholder="أدخل كلمة المرور">
                        </div>
                        <div class="mb-3 text-end">
                            <a href="#" class="forget">نسيت كلمة المرور؟</a>
                        </div>
                        <button type="submit" class="btn btn-primary w-100">تسجيل الدخول</button>
                    </form>

                    <p class="mt-3 no_account">
                        ليس لديك حساب؟ <a href="#" class="create">إنشاء حساب</a>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 d-none d-lg-block p-0">
                <img src="@/assets/images/cover.jpg" class="img-fluid vh-100 w-100" style="object-fit: cover;"
                    alt="Quran Image">
            </div>

        </div>
    </div>
</template>

<style scoped>
.login-container {
    min-height: 100vh;
}



h3 {
    font-size: 40px;
    font-weight: 500;
    margin-top: 30px;
}

input {
    width: 100%;
}

.ico {
    width: 16px;
    margin-inline-end: 5px;
    position: relative;
    bottom: 1px;
}

input.form-control {
    border: 1px solid #ced4da;
    box-shadow: none !important;
    transition: border-color 0.3s ease-in-out;
}

input.form-control:hover,
input.form-control:focus {
    border-color: #BF9F35 !important;
    outline: none !important;
    box-shadow: none !important;
}

.forget {
    font-size: 18px;
    font-weight: 400;
    color: #BF9F35;
    text-decoration: none;
    cursor: pointer;
}

.no_account {
    font-size: 18px;
    font-weight: 400;
    color: #3937357A;
}

.create {
    text-decoration: underline;
    color: #BF9F35;
}

@media (min-width: 992px) {
    .container {
        max-width: 100%;
    }
}

@media (min-width: 992px) {
    input {
        min-width: 400px;
    }
}
</style>